// Farm-management bulk-import template (public/files/farm-bulk-import/):
// localised download links, and header detection so the DDS production-place
// import can accept the same sheet.

// Languages that have a shipped _<lang> template; any other UI language gets English.
const SHIPPED_TEMPLATE_LANGUAGES = ["am","ar","el","es","fr","hi","id","it","mr","ne","nl","pt","sw","tr","vi"];

export function farmTemplateUrl(ext, language = localStorage.getItem("LANGUAGE") || "en") {
  const suffix = SHIPPED_TEMPLATE_LANGUAGES.includes(language) ? `_${language}` : "";
  return `/files/farm-bulk-import/farm-bulk-import-template${suffix}.${ext}`;
}

// Every translation of "I am not a farmer", "Geofence Coordinates" and
// "Geofence Type" (from the SaaS API headerTranslations,
// routes/admin/farm/bulk-upload/bulk-upload-language-support.js). The DDS
// template has none of these columns.
const FARM_TEMPLATE_MARKER_HEADERS = new Set([
  "I am not a farmer",
  "Non sono un agricoltore",
  "Ik ben geen boer",
  "म किसान होइन",
  "मी शेतकरी नाही",
  "Saya bukan petani",
  "Eu não sou um agricultor",
  "Je ne suis pas un agriculteur",
  "أنا لست مزارعًا",
  "Mimi si mkulima",
  "আমি কৃষক নই",
  "Ani si falmoo",
  "Aniga maahane beeraha",
  "Tôi không phải là một nông dân",
  "እኔ ተጠቃሚ አይደለም",
  "Δεν είμαι αγρότης",
  "我不是农民",
  "私は農家ではありません",
  "Ben bir çiftçi değilim",
  "मैं किसान नहीं हूं",
  "No soy un agricultor",
  "Geofence Coordinates",
  "Coordinate del geofence",
  "Geofence-coördinaten",
  "जिओफेन्स निर्देशांक",
  "Koordinat Geofence",
  "Coordenadas de geovalla",
  "Coordonnées de geovalla",
  "إحداثيات الجيوفنس",
  "Mipaka ya Geofence",
  "জিওফেন্স সংযোজন",
  "Qindeessitoota Geofence",
  "Isku-duwayaasha Geofence",
  "Tọa độ Geofence",
  "ጂኦፈንስ ኮንላት",
  "Συντεταγμένες Geofence",
  "地理围栏坐标",
  "ジオフェンス座標",
  "Jeofence Koordinatları",
  "जिओफेंस निर्देशांक",
  "Geofence Type",
  "Tipo di geofence",
  "Geofence-type",
  "जिओफेन्स प्रकार",
  "Jenis Geofence",
  "Tipo de geovalla",
  "Type de geovalla",
  "نوع الجيوفنس",
  "Aina ya geovalla",
  "জিওফেন্স টাইপ",
  "Gosa Geofence",
  "Nooca Geofence",
  "Loại Geofence",
  "የገበሬው አይነት",
  "Τύπος Geofence",
  "地理围栏类型",
  "ジオフェンスタイプ",
  "Jeofence Türü",
  "जिओफेंस प्रकार"
]);

// trim() also strips a leading UTF-8 BOM.
export function isFarmTemplateHeader(headers = []) {
  return headers.some(header => FARM_TEMPLATE_MARKER_HEADERS.has(String(header || "").trim()));
}
